import React from 'react';
import {
  Brain,
  Clock,
  Compass,
  Ear,
  Flag,
  HandHeart,
  Handshake,
  Heart,
  Lightbulb,
  ListChecks,
  MessageCircleQuestion,
  MessageSquareText,
  Scale,
  Shield,
  Smile,
  Sparkles,
  Target,
  Users,
  Wind,
  type LucideIcon,
} from 'lucide-react';

/** Mirrors SCORECARD_CATEGORY_ICONS in backend/api/utils/roleplay_scorecard.py. */
const SCORECARD_ICONS: Record<string, LucideIcon> = {
  Target,
  Heart,
  HandHeart,
  Ear,
  MessageSquareText,
  MessageCircleQuestion,
  Wind,
  Flag,
  Handshake,
  Lightbulb,
  Shield,
  Compass,
  Scale,
  Sparkles,
  Users,
  Clock,
  ListChecks,
  Smile,
  Brain,
};

export const ScorecardIcon: React.FC<{ name: string; size?: number; className?: string }> = ({
  name,
  size = 18,
  className,
}) => {
  const Icon = SCORECARD_ICONS[name] ?? Target;
  return <Icon size={size} aria-hidden="true" className={className} />;
};
